<template>
  <div>
    <CustomPageHeaderVue>{{ $t("contact_title") }}</CustomPageHeaderVue>
    <CustomRow>
      <v-card class="mt-5">
        <v-row class="my-0">
          <v-col cols="12" sm="6" class="cusPadding">
            <h3 class="primary-1--text mb-5">
              {{ $t("contact_service_email") }}
            </h3>
            <h2 class="font-weight-regular" style="margin-bottom: 30px">
              service@farentasia.com
            </h2>
            <h4 class="font-weight-regular">
              {{ $t("contact_service_email_notification") }}
            </h4>
          </v-col>
          <v-divider
            v-if="!$vuetify.breakpoint.xs"
            vertical
            style="margin: 125px 0"
          />
          <v-col v-else cols="12" class="px-15 py-0">
            <v-divider></v-divider>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            class="cusPadding"
            :class="{ 'mx-n3': !$vuetify.breakpoint.xs }"
          >
            <h3 class="primary-1--text mb-5">
              {{ $t("contact_service_phone") }}
            </h3>
            <h2 class="font-weight-regular" style="margin-bottom: 30px">
              02-2778-1570
            </h2>
            <h4
              class="font-weight-regular mb-3"
              v-html="$t('contact_service_phone_notification')"
            ></h4>
            <div
              class="text-small"
              v-html="$t('contact_service_phone_pay_notification')"
            ></div>
          </v-col>
        </v-row>
      </v-card>
    </CustomRow>
  </div>
</template>

<script>
import CustomPageHeaderVue from "@/components/CustomPageHeader.vue";

export default {
  components: { CustomPageHeaderVue },
  metaInfo() {
    return {
      title: `${this.$t("contact_title")} - ${this.$t("app_name")}`,
      meta: [
        {
          property: "og:title",
          content: `${this.$t("contact_title")} - ${this.$t("app_name")}`,
          vmid: "og:title",
        },
        {
          property: "og:url",
          content: window.location.origin + window.location.pathname,
          vmid: "og:url",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: `${this.$t("contact_title")} - ${this.$t("app_name")}`,
            url: window.location.origin + window.location.pathname,
          },
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.$gtm.trackView(`聯絡我們`, this.$route.path);
      this.$store.dispatch("setOverlayLoading", false);
    }, 200);
  },
};
</script>

<style lang="scss" scoped>
.cusPadding {
  text-align: center;
  padding: 85px 100px;

  @media screen and (max-width: 600px) {
    padding: 50px;
  }

  @media only screen and (min-width: 600px) and (max-width: 960px) {
    padding: 50px;
  }
}

.divvider {
  height: 50%;
  width: 1px;
  background-color: #c4c4c4;
  margin: auto;
}
</style>
